import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "../../components/Container/Container";
import Form from "../../components/Form/Form";
import Input from "../../components/Input/Input";
import Loader from "../../components/Loader/Loader";
import PageTitle from "../../components/PageTitle/PageTitle";
import Spacer from "../../components/Spacer/Spacer";
import Tabbar from "../../components/Tabbar/Tabbar";
import Tabbutton from "../../components/Tabbutton/Tabbutton";
import { useAuth } from "../../contexts/auth";
import UserService from "../../services/UserService";
import "./EditProfile.css";
import Form2fa from "./2fa/Form2fa";
import RoleSelection from "./RoleSelection/RoleSelection";
import Invites from "./Invites/Invites";
import { UrlPreference } from "./UrlPreference/UrlPreference";
import { useUserStore } from "../../contexts/userStore";
import { ThemePreference } from "./ThemePreference/ThemePreference";
import { ChangePhoto } from "./ChangePhoto/ChangePhoto";

const EditProfile = (props) => {
	const [senha, setSenha] = useState();
	const [confirmarSenha, setConfirmarSenha] = useState();
	const [senhaAntiga, setSenhaAntiga] = useState();
	const { user } = useAuth();
	const { getUrlPreference } = useUserStore();
	const [showLoader, setShowLoader] = useState(false);
	const navigate = useNavigate();
	const [tabContent, setTabContent] = useState(1);
	const { state } = useLocation();
	const selectedTab = state;

	useEffect(() => {
		if (selectedTab) setTabContent(selectedTab);
	}, [selectedTab]);

	async function handleSubmit(event) {
		event.preventDefault();
		if (!senhaAntiga) {
			NotificationManager.error("", "Senha atual é obrigatória", 3000, () => {
				alert("callback");
			});
			return;
		}
		if (senhaAntiga === senha) {
			NotificationManager.error("", "Digite uma nova senha que já não tenha utilizado", 3000, () => {
				alert("callback");
			});
			return;
		}
		if (confirmarSenha !== senha) {
			NotificationManager.error("", "Senhas não são iguais", 3000, () => {
				alert("callback");
			});
			return;
		}
		let payload = {
			id: user.userData.id,
			newPassword: senha,
			oldPassword: senhaAntiga,
		};
		setShowLoader(true);
		await UserService.changePassword(user.userData.id, payload);
		setShowLoader(false);
		navigate(getUrlPreference());
	}

	return (
		<Container className="edit-profile-container">
			{showLoader ? (
				<Loader />
			) : (
				<React.Fragment>
					<PageTitle title="Configurações"></PageTitle>
					<Spacer marginTop="10" />
					<Tabbar>
						<Tabbutton
							tabButtonLabel="Senha"
							tabId={1}
							handleClick={(tabId) => setTabContent(tabId)}
							tabSelected={tabContent}
						/>
						<Tabbutton
							tabButtonLabel="Foto"
							tabId={2}
							handleClick={(tabId) => setTabContent(tabId)}
							tabSelected={tabContent}
						/>
						<Tabbutton
							tabButtonLabel="Tema"
							tabId={3}
							handleClick={(tabId) => setTabContent(tabId)}
							tabSelected={tabContent}
						/>
						<Tabbutton
							tabButtonLabel="Autenticação"
							tabId={5}
							handleClick={(tabId) => setTabContent(tabId)}
							tabSelected={tabContent}
						/>
						{!user.userData.isSuperAdmin && (
							<Tabbutton
								tabButtonLabel="Perfis"
								tabId={6}
								handleClick={(tabId) => setTabContent(tabId)}
								tabSelected={tabContent}
							/>
						)}
						<Tabbutton
							tabButtonLabel="Tela Padrão"
							tabId={4}
							handleClick={(tabId) => setTabContent(tabId)}
							tabSelected={tabContent}
						/>
						{!user.userData.isSuperAdmin && (
							<Tabbutton
								tabButtonLabel="Convites"
								tabId={7}
								handleClick={(tabId) => setTabContent(tabId)}
								tabSelected={tabContent}
							/>
						)}
					</Tabbar>
					{tabContent === 1 && (
						<Form
							handleSubmit={handleSubmit}
							navigateCancelUrl={getUrlPreference()}
						>
							<div className="edit-profile-psw-inputs-wrap">
								<p className="edit-profile-title-details">
									Alterar Senha Cloud
								</p>
								<Input
									name="senhaAntiga"
									id="senhaAntiga"
									labelText="Digite sua senha atual *"
									value={senhaAntiga}
									type="password"
									autoComplete="on"
									onChange={({ target }) => setSenhaAntiga(target.value)}
									required={true}
								/>
								<Input
									name="senha"
									id="senha"
									labelText="Digite uma nova senha *"
									value={senha}
									type="password"
									autoComplete="on"
									onChange={({ target }) => setSenha(target.value)}
									required={true}
								/>
								<Input
									name="confirmar_senha"
									id="confirmar_senha"
									labelText="Confirme a nova senha *"
									value={confirmarSenha}
									type="password"
									autoComplete="on"
									onChange={({ target }) => setConfirmarSenha(target.value)}
									required={true}
								/>
							</div>
						</Form>
					)}

					{tabContent === 2 && (
						<ChangePhoto />
					)}

					{tabContent === 3 && (
						<ThemePreference />
					)}

					{tabContent === 4 && (
						<UrlPreference />
					)}

					{tabContent === 5 && (
						<div className="edit-profile-backup-container" style={{ display: 'flex', padding: '25px', flexDirection: 'column', alignItems: 'center' }}>
							<Form2fa />
						</div>
					)}

					{tabContent === 6 && !user.userData.isSuperAdmin && (
						<RoleSelection />
					)}

					{tabContent === 7 && !user.userData.isSuperAdmin && (
						<Invites />
					)}
				</React.Fragment>
			)}
		</Container>
	);
};

export default EditProfile;
